import React, { memo, useMemo } from "react";
import { Handle, Position } from "@xyflow/react";
import { ViewList } from "@mui/icons-material";
import NodeWrapper from "./NodeWrapper";

function getAllListRows(sections) {
  if (!Array.isArray(sections)) return [];
  return sections.flatMap((sec) =>
    (sec.rows || [])
      .map((r) => {
        const id =
          r?.id != null && String(r.id).trim() !== ""
            ? String(r.id).trim()
            : r?.rowId != null && String(r.rowId).trim() !== ""
              ? String(r.rowId).trim()
              : null;
        if (!id) return null;
        const title = (r?.title && String(r.title).trim()) || "";
        return { id, label: title || id };
      })
      .filter(Boolean)
  );
}

const ListNode = memo(({ id, data, isConnectable, selected }) => {
  const sections = data?.sections || [];
  const listRows = useMemo(() => getAllListRows(sections), [sections]);

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<ViewList />}
      title="Lista"
      color="#683AC8"
      bgColor="#FAFBFF"
      noSource
      isConnectable={isConnectable}
      selected={selected}
      minWidth={220}
    >
      {/* Message preview */}
      <div
        style={{
          fontSize: 11, color: "#333", lineHeight: 1.4, marginBottom: 6,
          overflow: "hidden", textOverflow: "ellipsis",
          display: "-webkit-box", WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical", maxWidth: 200,
        }}
      >
        {data?.message || "Mensagem com lista"}
      </div>

      {/* Section/row count summary */}
      {(sections.length > 0 || listRows.length > 0) && (
        <div style={{
          display: "inline-flex", alignItems: "center", gap: 8,
          fontSize: 10, color: "#78909C", marginBottom: 6,
        }}>
          <span style={{
            padding: "1px 6px", borderRadius: 4,
            backgroundColor: "#EDE7F6", color: "#683AC8", fontWeight: 600,
          }}>
            {sections.length} secao(oes)
          </span>
          <span style={{
            padding: "1px 6px", borderRadius: 4,
            backgroundColor: "#F3E5F5", color: "#7B1FA2", fontWeight: 600,
          }}>
            {listRows.length} opcao(oes)
          </span>
        </div>
      )}

      {/* Row labels with handles at node edge */}
      {listRows.length > 0 && (
        <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
          {listRows.map(({ id: rowId, label }) => (
            <div
              key={rowId}
              style={{
                display: "flex", alignItems: "center", gap: 6,
                fontSize: 10, color: "#444", fontWeight: 500,
                padding: "3px 6px", borderRadius: 4,
                backgroundColor: "#FAFAFA", border: "1px solid #f0f0f0",
                position: "relative",
              }}
            >
              <span style={{
                flex: 1, overflow: "hidden", textOverflow: "ellipsis",
                whiteSpace: "nowrap", textAlign: "right",
              }}>
                {label}
              </span>
              <Handle
                type="source"
                position={Position.Right}
                id={`lst_${rowId}`}
                style={{
                  position: "absolute",
                  top: "50%",
                  right: -21,
                  transform: "translateY(-50%)",
                  background: "#683AC8",
                  width: 14, height: 14,
                  border: "2px solid #FAFBFF",
                  borderRadius: "50%",
                  cursor: "crosshair",
                }}
                isConnectable={isConnectable}
              />
            </div>
          ))}
        </div>
      )}
    </NodeWrapper>
  );
});

ListNode.displayName = "ListNode";
export default ListNode;
